export var PaymentIssues;
(function (PaymentIssues) {
    PaymentIssues["HardshipArrangements"] = "HARDSHIP_ARRANGEMENTS";
    PaymentIssues["LatePayments"] = "LATE_PAYMENTS";
    PaymentIssues["MissedPayments"] = "MISSED_PAYMENTS";
    PaymentIssues["OutstandingArrears"] = "OUTSTANDING_ARREARS";
    PaymentIssues["None"] = "NONE";
})(PaymentIssues || (PaymentIssues = {}));
//# sourceMappingURL=PaymentIssues.js.map